import {NgModule} from '@angular/core';
import {DynamicPageComponent} from "@iw-shop/dynamic-page/components/dynamic-page.component";
import {CommonModule, NgIf} from "@angular/common";
import {CoreModule} from "@iw-shop/core/core.module";
import {ImageSliderComponent} from "@iw-shop/dynamic-page/components/image-slider/image-slider.component";
import {CarouselModule} from "primeng/carousel";
import {
    DefaultWithdrawalComponent
} from "@iw-shop/dynamic-page/components/default-withdrawal/default-withdrawal.component";
import {
    DefaultTermsAndConditionsComponent
} from "@iw-shop/dynamic-page/components/default-terms-and-conditions/default-terms-and-conditions.component";
import {DefaultImprintComponent} from "@iw-shop/dynamic-page/components/default-imprint/default-imprint.component";

@NgModule({
    declarations: [
        DynamicPageComponent,
        ImageSliderComponent,
        DefaultWithdrawalComponent,
        DefaultTermsAndConditionsComponent,
        DefaultImprintComponent
    ],
    imports: [
        NgIf,
        CommonModule,
        CoreModule,
        CarouselModule
    ],
    providers: [
    ],
    exports: [
        ImageSliderComponent,
        DynamicPageComponent,
        DefaultWithdrawalComponent,
        DefaultTermsAndConditionsComponent,
        DefaultImprintComponent
    ]
})
export class DynamicPageModule {
}
